import React from "react";
import Upload from "./Upload";

const TeacherComplain = () => {
  return (
    <div>
      <Upload />
    </div>
  );
};

export default TeacherComplain;
